// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as TbUtils17 from "./TbUtils17.bs.js";
import * as TeamPlannerHex17 from "./TeamPlannerHex17.bs.js";

function HexPreview17(Props) {
  var unitId = Props.unitId;
  var unitItems = Props.unitItems;
  var starLevel = Props.starLevel;
  var traitCounts = Props.traitCounts;
  var modifier = Props.modifier;
  return React.createElement("g", {
              transform: "translate(3, 0)"
            }, React.createElement("g", {
                  className: "scale-50 sm:scale-100"
                }, React.createElement(TeamPlannerHex17.Unit.make, {
                      isDragging: false,
                      hexSize: 50,
                      hex: {
                        unit: TbUtils17.Content.decodeStr(unitId),
                        items: unitItems,
                        starLevel: starLevel,
                        chosenTrait: 0,
                        modifier: modifier
                      },
                      colNum: 0,
                      rowNum: 0,
                      onRemove: (function (param) {
                          
                        }),
                      onRemoveItem: (function (param, param$1, param$2) {
                          
                        }),
                      onUpdateHex: (function (param, param$1, param$2) {
                          
                        }),
                      onToggleMech: (function (param, param$1, param$2) {
                          
                        }),
                      traitCounts: traitCounts,
                      exaltedUnits: []
                    })));
}

var make = React.memo(HexPreview17);

export {
  make ,
  
}
/* make Not a pure module */
